import lrSelectBox from './_src/lrSelectBox.vue'

lrSelectBox.install = function(Vue) {
  Vue.component(lrSelectBox.name, lrSelectBox)
}

export default lrSelectBox